import {
  getRequest,
  putRequest,
  postRequest,
} from './../../../servos/apiRequests'

const onSuccess = (data) => {
  return { response: data.data }
}

const onFailure = (error) => {
  return { error }
}

export const getLoanApplication = (id) => {
  let url = `/loan_applications/${id}.json`

  return getRequest({ url, onSuccess: onSuccess, onFailure: onFailure })
}

export const updateLoanApplication = (id, data) => {
  let url = `/loan_applications/${id}.json`

  return putRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}
export const postLoanSetupCalculator = (id, data) => {
  let url = `/loan_applications/${id}/calculators/loan_setup.json`

  return postRequest({ url, data, onSuccess: onSuccess, onFailure: onFailure })
}
